import { ApiConstants } from '@epi-constants/actions';
import createReducer from '@epi-helpers/CreateReducer';

interface State {
  isLoading: string[];
  noPersistance: boolean;
}

export const getInitialState = (): State => ({
  isLoading: [],
  noPersistance: true
});

const AddId = (state: State, id: string): string[] => [...state.isLoading, id];

const RemoveId = (state: State, id: string): string[] => [
  ...(state.isLoading || []).filter(value => value !== id)
];

export default createReducer(getInitialState, {
  [`${ApiConstants.GET_RECEIPT_FOR_TRANSACTION}_REQUEST`]: (
    state: State,
    { id }: { id: string }
  ) => ({
    isLoading: AddId(state, `transaction-${id}`)
  }),

  [`${ApiConstants.GET_RECEIPT_FOR_TRANSACTION}_SUCCESS`]: (
    state: State,
    { id }: { id: string }
  ) => ({
    isLoading: RemoveId(state, `transaction-${id}`)
  }),

  [`${ApiConstants.GET_RECEIPT_FOR_TRANSACTION}_FAILURE`]: (
    state: State,
    { id }: { id: string }
  ) => ({
    isLoading: RemoveId(state, `transaction-${id}`)
  })
});
